import React, { Component }  from 'react'
import { Col, Row } from 'reactstrap';

export default class General extends Component {
	

	render() {
		return (
			<>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_company">Tên công ty</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_company} onChange={this.props.onChangeValue} className="form-control" id="website_company" name="website_company" placeholder="Tên công ty" />
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_company">Website Title</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_title} onChange={this.props.onChangeValue} className="form-control" id="website_title" name="website_title" placeholder="Website Title"  />
						<div className="text-danger">
							<b>⁕Lưu ý:</b> Tiêu đề hiển thị trên tab trình duyệt và hiển thị tiêu đề trong các bộ kết quả tìm kiếm
						</div>
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_name">Tên hệ thống</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_name} onChange={this.props.onChangeValue} className="form-control" id="website_name" name="website_name" placeholder="Tên hệ thống"  />
						<div className="text-danger">
							<b>⁕Lưu ý:</b> Tên hệ thống sẽ được hiển thị trong toàn bộ các trang
						</div>
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_email">Địa chỉ Email</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_email} onChange={this.props.onChangeValue} className="form-control" id="website_email" name="website_email" placeholder="Địa chỉ Email"  />
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_address">Địa chỉ</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_address} onChange={this.props.onChangeValue} className="form-control" id="website_address" name="website_address" placeholder="Địa chỉ"  />
					</Col>
				</Row>   

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_domain">Domain</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_domain} onChange={this.props.onChangeValue} className="form-control" id="website_domain" name="website_domain" placeholder="Domain"  />
					</Col>
				</Row> 	 

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_phone">Số điện thoại</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_phone} onChange={this.props.onChangeValue} className="form-control" id="website_phone" name="website_phone" placeholder="" />
					</Col>
				</Row>

                <Row className="form-group row">
                    <Col md={2} className="col-form-label">
                        <label htmlFor="website_link_role">Liên kết điều khoản dịch vụ</label>
                    </Col>
                    <Col md={10}>
                        <input type="text" value={this.props.general.website_link_role} onChange={this.props.onChangeValue} className="form-control" id="website_link_role" name="website_link_role" placeholder="" />
                    </Col>
                </Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_facebook_url">Facebook URL</label>
					</Col>
					<Col md={10}>
						<input type="text" value={this.props.general.website_facebook_url} onChange={this.props.onChangeValue} className="form-control" id="website_facebook_url" name="website_facebook_url" placeholder="Facebook URL"  />
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_logo">Website Logo</label>
					</Col>
					<Col md={10}>
						{
							this.props.imagesShow.website_logo ? (
								<img className="config-image" src={ this.props.imagesShow.website_logo } alt="Website Logo" height={160} />
							) : (
								<></>
							)
						}
						<input type="file" name="website_logo" onChange={this.props.onChangeValue} id="website_logo" placeholder="Logo" className="form-control" />
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_logo_w">Logo trắng</label>
					</Col>
					<Col md={10}>
						{
							this.props.imagesShow.website_logo_w ? (
								<img className="config-image logo-w" src={ this.props.imagesShow.website_logo_w } alt="Website Logo White" height={160} />
							) : (
								<></>
							)
						}
						<input type="file" name="website_logo_w" onChange={this.props.onChangeValue} id="website_logo_w" placeholder="Logo" className="form-control" />
					</Col>
				</Row>

				<Row className="form-group row">
					<Col md={2} className="col-form-label">
						<label htmlFor="website_favicon">Favicon</label>
					</Col>
					<Col md={10}>
						{
							this.props.imagesShow.website_favicon ? (
								<img className="config-image favicon-image"src={ this.props.imagesShow.website_favicon } alt="Website Favicon" height={160} />
							) : (
								<></>
							)
						}
						<input type="file" name="website_favicon" onChange={this.props.onChangeValue} id="website_favicon" placeholder="Favicon" className="form-control" />
					</Col>
				</Row>
				
				</>
				)
}
}